import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalControlService } from '../global-control.service';
import { GC_SUFFIX, LogEntry } from '../global-controls.constant';
@Component({
  selector: 'cygov-global-controls-logs',
  templateUrl: './global-controls-logs.component.html',
  styleUrls: ['./global-controls-logs.component.scss'],
  standalone: false,
})
export class GlobalControlsLogsComponent implements OnInit {
  @Input() currentRootEntity: string = null; //* Current Root Entity
  @Output() logsDismissed: EventEmitter<boolean> = new EventEmitter<boolean>();

  logsList: LogEntry[] = []; //* List of all logs
  isLoading: boolean = false; //* Flag to indicate loading state

  constructor(private globalCOntrolService: GlobalControlService) {}

  ngOnInit() {
    this.getLogsFromDB();
  }

  async getLogsFromDB() {
    try {
      this.isLoading = true;
      const response = await this.globalCOntrolService.getLogsByTargetId(`${this.currentRootEntity}#${GC_SUFFIX}`);
      this.logsList = response || [];
    } catch (error) {
      console.error('Error fetching logs:', error);
      return Promise.reject(error);
    } finally {
      this.isLoading = false;
    }
  }

  closeLogs() {
    this.logsDismissed.emit(true);
  }
}
